import React from "react";
import {BaseContactFormContainer} from "app/contacts/components/BaseContactForm/BaseContactFormContainer";

export const RegistrantGovContactForm = (props) =>
    <BaseContactFormContainer {...props} isRegistrant={true} isGov= {true}/>